import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { SegmentExport } from '@feathr/blackbox';
import ProgressCell from '@feathr/extender/components/ProgressCell';

import { getProgressMode } from './ExportProgressCell.utils';

interface IExportProgressCellProps {
  segmentExport: SegmentExport;
}

function ExportProgressCell({ segmentExport }: Readonly<IExportProgressCellProps>): JSX.Element {
  const { t } = useTranslation();
  const mode = getProgressMode({
    state: segmentExport.get('state'),
    progress: segmentExport.get('progress'),
  });

  return <ProgressCell label={t('Export progress')} mode={mode} />;
}

export default observer(ExportProgressCell);
